import React from "react";
import {useSelector} from "react-redux";
import map from '../config/map';
import namedMap from "../config/namedMap";

const Router = () => {
    const {app: {page, namedPage}} = useSelector((state) => state);

    if (namedPage && namedMap.hasOwnProperty(namedPage)) {
        return namedMap[namedPage];
    } else if (map[page] !== undefined) {
        return map[page];
    } else {
        return (<p>Index out of bounds</p>);
    }
}

export default Router;
